import * as React from 'react'
import { OfflineIcon } from '../offline/icon'

export interface IProps {
  message?: string
}
export const AninixUnavailable: React.FCC<IProps> = ({
  message = 'We could not connect to our servers. Please restart Figma and Aninix plugin and try again.',
}) => (
  <div className="mx-auto flex h-screen w-screen max-w-sm flex-col items-center justify-center text-center text-black/80">
    <OfflineIcon className="w-[258px]" />

    <p className="mt-6 text-2xl font-semibold">Unable to connect to Aninix</p>

    <p className="mt-2 text-base">{message}</p>

    <p className="mt-1 text-base">
      If the issue keeps happening,{' '}
      <a
        href="mailto:info@aninix.com"
        target="_blank"
        className="text-[#18A0FB]"
        rel="noreferrer"
      >
        contact us.
      </a>
    </p>
  </div>
)

AninixUnavailable.displayName = 'Offline'
